import React, * as react from "react";
import {BrowserRouter as Router, Redirect, Route} from "react-router-dom";
import queryString from "query-string";

import * as jotoui from "../joto-ui-api";
import * as jotoTypes from '../api/joto-types';
import * as jotouiutils from './JotoUIUtils'

import * as log from 'loglevel';

// log.setDefaultLevel(log.levels.DEBUG);
const logger = log.getLogger('handle-index-routes.tsx');

interface HandleIndexRoutesProps {
    jotoui: jotoui.JotoUIApi,
}

// http://localhost:3000/index.html?uid=LTGgFOBshcRQDutpH35QFWyNzz02&pid=00
const HandleIndexRoutes : react.FunctionComponent<HandleIndexRoutesProps> = (handleIndexRoutesProps : HandleIndexRoutesProps) => {
    const routePrefix = '/index.html';

    return <Router>
        <Route path={routePrefix} exact={true} render={(props) => {
            const search = props.location.search;
            logger.debug(`handle-index-routes.tsx location search: "${search}"`);
            if(search.trim().length > 0) {
                const values_ = queryString.parse(search);
                logger.debug(`handle-index-routes.tsx location values: "${JSON.stringify(values_)}"`);
                const {uid, pid} = (({uid, pid}) => ({uid, pid}))(values_);
                if(typeof uid == 'string' && jotoTypes.isValidPidValue(pid)) {
                    handleIndexRoutesProps.jotoui.showProjectDetailPage({uid, pid});
                    (async () => {
                        await jotouiutils.sleep(0);
                        (window as any).$('#main-selected-project-modal-view').modal('show');
                    })();
                } else {
                    throw new Error(`HandleIndexRoutes: invalid values for uid, pid: ${uid}, ${pid}`);
                }
                return <Redirect to={'/'}/>
            }
            return null;
        }}/>
    </Router>;
};

export {HandleIndexRoutes}
